function indexSwiper() {
  const targetElements = document.querySelector(".index-user-swiper");
  if (!targetElements) return;
  const indexUserStoryList = document.querySelector(".index-user-story-list");
  if (!indexUserStoryList) return;

  // var slidesPerView = isMobile() ? 1.1 : 3.1;
  const swiper = new Swiper(targetElements, {
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: true,
    initialSlide: 1,
    breakpoints: {
      750: {
        spaceBetween: 10,
        slidesPerView: 2,
        centeredSlides: false,
        initialSlide: 0,
      },
      1024: {
        spaceBetween: 24,
        slidesPerView: 3,
        centeredSlides: false,
        initialSlide: 0,
      }
    },
    navigation: {
      nextEl: ".index-user-story-list .swiper-button-next",
      prevEl: ".index-user-story-list .swiper-button-prev"
    },
    pagination: {
      el: ".index-user-swiper .swiper-pagination",
      clickable: true,
    }
  });
  if (swiper) {
    targetElements.style.display = "block";
    
    const spinner = document.querySelector(".index-user-story-list .swiper-spinner");
    const btnList = document.querySelector(".index-user-story-list .swiper-btn-list");

    if (spinner) spinner.style.display = "none";
    if (btnList) btnList.style.opacity = 1;
  }
}
function isMobile() {
  return window.matchMedia('(max-width: 750px)').matches
}
// 用户故事列表
function userstory() {
  //暂时不使用
  return  
  var url = "https://api.bluettipower.com/brandapi/userstory/list?current=1&size=6&shop=" + Shopify.shop.split(".myshopify")[0];
  var swiperWrapper = document.querySelector(".index-user-swiper .swiper-wrapper");
  if (!swiperWrapper) return;
  var temp = swiperWrapper.innerHTML;

  if (!document.querySelector(".index-user-swiper")) return;
  fetch(url, {
    headers: {
      'shop': Shopify.shop.split(".myshopify")[0]
    },
  }).then((response) => response.json()).then((res) => {

    if (res.code == 0) {
      var data = res.data || {};
      var list = data.records || [];
      document.querySelector(".index-user-swiper .swiper-wrapper").innerHTML = "";
      console.log('############', list);
      
      list.forEach(item => {
        var warp = document.createElement("div");
        var link = "https://www.bluettipower.com/pages/home-energy-user-stories?id=" + item.id;
        warp.setAttribute("class", "swiper-slide");
        warp.innerHTML = temp;
        warp.querySelector(".story-image").href = link;
        warp.querySelector(".story-link").href = link;
        warp.querySelector("img").src = item.coverImage;
        warp.querySelector("img").alt = item.title;
        warp.querySelector("p").innerHTML = item.title;
        document.querySelector(".index-user-swiper .swiper-wrapper").append(warp);
      });

      setTimeout(() => { indexSwiper(); }, 1000);
    }
  })
}

// 首页博客swiper
function indexBlogSwiper() {
  var temp = document.querySelector(".index-blog-list .index-blog-swiper");
  if (!temp) return;
  const swiper = new Swiper(temp, {
    slidesPerView: "auto",
    spaceBetween: 10,
    initialSlide: 1,
    centeredSlides: true,
    breakpoints: {
      //当屏幕宽度大于等于750
      750: {
        spaceBetween: 10,
        slidesPerView: 2,
        initialSlide: 1,
        centeredSlides: false,
      },
      1024: {
        spaceBetween: 24,
        slidesPerView: 2,
        initialSlide: 1,
        centeredSlides: false,
      },
      //当屏幕宽度大于等于1440
      1440: {
        spaceBetween: 24,
        slidesPerView: 2,
        initialSlide: 1,
        centeredSlides: false,
      }
    },
    pagination: {
      el: document.querySelector(".index-blog-list .swiper-pagination"),
      clickable: true,
    },
    navigation: {
      nextEl: document.querySelector(".index-blog-list .swiper-button-next"),
      prevEl: document.querySelector(".index-blog-list .swiper-button-prev")
    }
  })
  // const actualSlidesCount = swiper.slides.not('.swiper-slide-duplicate').length;
  // const initialSlideIndex = Math.floor(actualSlidesCount / 2);
  // swiper.update(); // 更新 Swiper
  if (swiper) {
    temp.style.display = "block";
    document.querySelector(".index-blog-list .swiper-spinner").style.display = "none";
    document.querySelector(".index-blog-list .swiper-control-info").style.display = "block";
  }
}

//首页媒体获奖背书swiper  代码弃用：创建了index-user-story.js组件
// function indexMediumSwiper() {
//   const targetElements2 = document.querySelector(".index-medium-swiper");
//   if (!targetElements2) return;

//   const swiper2 = new Swiper(targetElements2, {
//     spaceBetween: 12,
//     autoplay: {
//       delay: 5000,
//     },
//     breakpoints: {
//       1440: {
//         spaceBetween: 128,
//       },
//       750: {
//         spaceBetween: 20,
//       }
//     },
//     navigation: {
//       nextEl: document.querySelector(".index-medium-layout .swiper-button-next"),
//       prevEl: document.querySelector(".index-medium-layout .swiper-button-prev")
//     },
//     // scrollbar: {
//     //   el: ".swiper-scrollbar",
//     // }
//   })
//   // if(swiper2){
//   //     targetElements2.style.display = "block";
//   //     document.querySelector(".index-medium-layout .swiper-spinner").style.display="none";
//   //     document.querySelector(".index-medium-layout .swiper-btn-list").style.opacity=1;
//   // }
// }

window.onload = function () {

  userstory();

  indexBlogSwiper();

  // indexMediumSwiper();
}



